module.exports = __webpack_public_path__ + "img/size.5b470b16.svg";